"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AlertSuccessIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("circle", { cx: "12", cy: "12", r: "10", fill: props.color }),
        react_1.default.createElement("path", { d: "M11.2121 15.8459C11.1071 15.9448 10.9638 16 10.815 16C10.6662 16 10.523 15.9448 10.418 15.8459L7.24682 12.8752C6.91773 12.567 6.91773 12.0672 7.24682 11.7595L7.64389 11.3875C7.97309 11.0793 8.50612 11.0793 8.83522 11.3875L10.815 13.242L16.1648 8.23118C16.494 7.92294 17.0275 7.92294 17.3561 8.23118L17.7532 8.60318C18.0823 8.91142 18.0823 9.41115 17.7532 9.7189L11.2121 15.8459Z", fill: "white" })));
};
exports.default = AlertSuccessIcon;
